import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "spinner" }
const _hoisted_2 = {
  class: "circular",
  viewBox: "25 25 50 50"
}
const _hoisted_3 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'SpinnerComponent',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "loader",
      style: _normalizeStyle('width:' + __props.width + 'px')
    }, [
      (_openBlock(), _createElementBlock("svg", _hoisted_2, [
        _createElementVNode("circle", {
          class: "path",
          cx: "50",
          cy: "50",
          r: "20",
          fill: "none",
          stroke: __props.color ? __props.color : 'var(--accent-color)',
          "stroke-width": "5",
          "stroke-miterlimit": "10"
        }, null, 8, _hoisted_3)
      ]))
    ], 4)
  ]))
}
}

})